module.exports = __webpack_public_path__ + "static/img/2_1_3.f2908664.jpg";